/**   
 * api接口统一管理
 */
import { get} from './http'
export const getAudioList = p => get('article/list', p);
export const getHomeGridList = p => get('app/grid', p);
export const getProductList = p => get('product/list', p);